import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {ProfileReference} from '@github-ui/profile-reference'
import {Link} from '@github-ui/react-router'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {ThreadGroupVariant, getThreadAuthorLogin, ThreadGroupVariantLabels} from '../util/classify-thread'
import {getCommentSnippet, getInitialComment} from '../util/thread-comment-accessors'
import styles from './ThreadTitle.module.css'

function ThreadMessage({thread, variant}: {thread?: Thread | null; variant: ThreadGroupVariant}) {
  if (variant === ThreadGroupVariant.Replied) {
    const initialComment = thread ? getInitialComment(thread) : undefined
    if (initialComment) {
      return (
        <>
          <span>&nbsp;replied to &ldquo;</span>
          <span className={styles.truncateSnippet}>{getCommentSnippet(initialComment)}</span>
          <span>&rdquo;</span>
        </>
      )
    }
  }

  return <span>&nbsp;{ThreadGroupVariantLabels[variant] || 'commented'}</span>
}

export function ThreadTitle({thread, variant}: {thread?: Thread | null; variant: ThreadGroupVariant}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()

  const message = <ThreadMessage thread={thread} variant={variant} />

  // Falls back to the ghost user (login `ghost`, profile `/ghost`) when the
  // comment author no longer exists, matching the expanded thread view.
  const authorLogin = getThreadAuthorLogin(thread, variant)

  return (
    <span className={styles.ThreadTitle}>
      <Link
        to={`/${authorLogin}`}
        className="color-fg-default text-bold"
        {...getHovercardAttributesForType('user', {login: authorLogin})}
      >
        <ProfileReference login={authorLogin} isAgent={false} />
      </Link>
      {message}
    </span>
  )
}
